export default `
    {{ variable }} = hmUI.createWidget(hmUI.widget.WATCHFACE_EDIT_FG_MASK,{
      x: 0,
      y: 0,
      w: {{ width }},
      h: {{ height }},
      {{ #mask }}
      src: '{{{ mask }}}',
      {{ /mask }}
      show_level:hmUI.show_level.ONLY_EDIT,
    });
  `
